
import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { createBrowserHistory } from "history";
import { toastr } from "react-redux-toastr";
import CouponTimePicker from './component'
import LoadingSpinner from "../../Loading/component";
import { useNavigate } from "react-router-dom";
// import  CouponDeeplinkComponent  from "./component";
import { onChange_CouponDescription_Step2 } from "../CouponCreate/action";
import { onChange_CouponImage_Step3 } from "../CouponCreate/action";
import { onChange_CouponDate_Step4 } from "../CouponCreate/action";
import { onChange_CouponDeeplink_Step5 } from "../CouponCreate/action";
import { toast } from "react-toastify";
import './component.css'


const CouponTimeSlot = (props) => {
  console.log("CouponDesContainer props",props)
  const [deeplink, setDeeplink] = useState("");
  
  const navigate = useNavigate();
  
  const buildInitialSlotState = (isTimeSlot) => ({
  isTimeSlot: isTimeSlot,
  ...Array.from({ length: 24 }, (_, i) => {
    const start = String(i).padStart(2, '0');
    const end = String((i + 1) % 24).padStart(2, '0');
    return { [`${start}-${end}`]: null };
  }).reduce((acc, curr) => ({ ...acc, ...curr }), {})
});

const hours = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));


  const [timePairs, setTimePairs] = useState([{ start: '00', end: '01' }]);
  const [finalData, setFinalData] = useState(null);
   const [active, setActive] = useState('yes');
   const updatePair = (index, field, value) => {
    const updated = [...timePairs];
    updated[index][field] = value;

    if (field === 'start') {
      const autoEnd = String((parseInt(value) + 1) % 24).padStart(2, '0');
      updated[index].end = autoEnd;
    }

    setTimePairs(updated);
  }; 

  const addPair = () => {
    setTimePairs([...timePairs, { start: '00', end: '01' }]);
  }; 

   const removePair = (index) => {
    const updated = [...timePairs];
    updated.splice(index, 1);
    setTimePairs(updated);
  }; 

  const buildFinalObject = (isTimeSlot) => {
    const base = buildInitialSlotState(isTimeSlot);
    timePairs.forEach(({ start, end }) => {
      const key = `${start}-${end}`;
      if (base.hasOwnProperty(key)) {
        base[key] = true;
      }
    });
    return base;
  };
 



  const couponCreationStep5 = () => {
   
   
    console.log("CKICK",localStorage.getItem("draftId"))
     if(deeplink===""){
      toastr.warning("Enter Coupon Deeplink")
      return;
    } 

    props.getDataFromAPI(

      `/partner/api/v1/coupon/create/draft`,
      "POST",
      {
        step: 21,
        draftId:props.props&&props.props.coupon.step1_draftId,
        deeplink: deeplink,
      },
      (response) => {
        console.log("API response step 2:", response);
        setDeeplink(deeplink)
      
        props.onChange_CouponDescription_Step2(response)
        props.onChange_CouponImage_Step3(response)
        props.onChange_CouponDate_Step4(response)
        props.onChange_CouponDeeplink_Step5(response)
       
       
        navigate("/home/coupondiscountamount");
      },
      (err) => {
        toastr.error("Error", "Failed to create coupon.");
      },
      true
    );
   
  };
  
  const couponCreationStep6 = (e,isTimeSlot) => {

      

           const fullPayload = {
       step: 21,
        draftId:props.props&&props.props.coupon.step1_draftId,
      couponTimeSlot: buildFinalObject(isTimeSlot),
      isTimeSlot:active=='yes'?true:false
    };

    console.log("couponCreationStep4",fullPayload)
    props.getDataFromAPI(

      `/partner/api/v1/coupon/create/draft`,
      "POST",
     fullPayload,
      (response) => {
        console.log("API response step 3:", response);
        localStorage.getItem("draftId", response.draftId)
      
               //setCouponExpiry(couponExpiry)
               props.onChange_CouponDescription_Step2(response)
               props.onChange_CouponImage_Step3(response)
               props.onChange_CouponDate_Step4(response)
              
               navigate("/home/coupondeeplink");
      
      },
      (err) => {
       toastr.error((`${err.message}`),{
            position:toast.POSITION.TOP_RIGHT,
            autoClose:1000
          });
      },
      true
    );
    //navigate("/couponimage");
  };

    
  
  return (
    <>
   
  <CouponTimePicker
   addPair={addPair}
          active={active}
      
          setActive={setActive}
          updatePair={updatePair}
          hours={hours}
          setFinalData={setFinalData}
          setTimePairs={setTimePairs}
          couponCreationStep6={couponCreationStep6}
          timePairs={timePairs}
          removePair={removePair}

          
          
 
  />
     
    </>
  
  )
}

function mapStateToProps(props ) {
    return {
      props,
     
    };
  }
  export default connect(mapStateToProps, {
    getDataFromAPI,
    onChange_CouponDescription_Step2,
    onChange_CouponImage_Step3,
    onChange_CouponDate_Step4,
    onChange_CouponDeeplink_Step5,
    
  })(CouponTimeSlot);
